import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AppointmentModal from "./components/Home/AppointmentModal";
import FloatingButtons from "./components/FloatingButtons";
import PromotionalItems from "./components/Home/PromotionalItems";

import Hero from './components/Home/Hero';
import MobileHero from "./components/Home/Mobile_Hero";
import Services from "./components/Home/Services";
import About from "./components/Home/About";
import TopCategories from "./components/Home/TopCategories";
import OurProducts from "./components/Home/OurProducts";
import WhyChooseUs from "./components/Home/WhyChooseUs";
import Testimonials from "./components/Home/Testimonials";
import Faqs from "./components/Home/Faqs";

import Condition from "./components/pages/Condition";
import Policy from "./components/pages/Policy";
import ThankYou from "./components/pages/ThankYou";

function App() {
  const [showModal, setShowModal] = useState(false);

  return (
    <BrowserRouter>
      <ScrollToTop />

      <Header setShowModal={setShowModal} />

      <Routes>

          {/* Home */}
          {["/", "/pcd-pharma-franchise"].map((path) => (
            <Route
              key={path}
              path={path}
              element={
                <>
                  <Hero setShowModal={setShowModal} />
                  <MobileHero setShowModal={setShowModal} />
                  <Services setShowModal={setShowModal} />
                  <About setShowModal={setShowModal} />
                  <TopCategories setShowModal={setShowModal} />
                  <OurProducts setShowModal={setShowModal} />

                  {/* <WoodStain/> */}
                  {/* <PuPaint/>
                  <Thinner/> */}
                  {/* <Certificate /> */}
                  <WhyChooseUs setShowModal={setShowModal} />
                  {/* <BusinessSolutions setShowModal={setShowModal} /> */}
                  <Testimonials setShowModal={setShowModal} />
                  <PromotionalItems />
                  <Faqs setShowModal={setShowModal} />
                </>
              }
            />
          ))}

          {/* Legal Pages */}
          <Route path="/terms-and-conditions" element={<Condition />} />
          <Route path="/privacy-policy" element={<Policy />} />
          <Route path="/thank-you" element={<ThankYou />} />

        </Routes>

      <Footer setShowModal={setShowModal} />
      <FloatingButtons setShowModal={setShowModal} />
      <AppointmentModal show={showModal} onHide={() => setShowModal(false)} />
    </BrowserRouter>
  );
}

export default App;
